import '../css/main.css'
import { Link, useNavigate } from "react-router-dom"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass, faCircleXmark, faSortDown, faSortUp, faWindowMinimize } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { checkLogin } from '../../store';
import { SyncLoader } from "react-spinners";
import Message from '../common/message';

function Common() {
    const [reload, setReload] = useState(false);
    const [spinner, setSpinner] = useState(false);
    const [message, setMessage] = useState({ code: -1, msg: "" });

    const dark = useSelector((state) => state.Darkmode.value);
    const darkname = dark ? "dark" : "";

    const dispatch = useDispatch();
    const navigate = useNavigate();

    // 수정 모드 토글 (false=보기모드, true=수정모드)
    const [changeValue, setChangeValue] = useState(false);

    /**
     * 서버에서 받아온 4개 항목(약관, 개인정보, 준비중, 미니앱 봇)을 저장.
     * - commonData: 현재 화면에서 표시/수정되는 값
     * - originalData: 서버에서 불러온 원본 값 (취소 시 복원용)
     */
    const [commonData, setCommonData] = useState({
        termUrl: "",
        privacyUrl: "",
        prepareUrl: "",
        telegramMiniappUrl: "",
    });
    const [originalData, setOriginalData] = useState({
        termUrl: "",
        privacyUrl: "",
        prepareUrl: "",
        telegramMiniappUrl: "",
    });

    // 로그인 체크
    useEffect(() => {
        const objString = localStorage.getItem("token");
        if (objString != null) {
            const obj = JSON.parse(objString);
            if (Date.now() > obj.expire) {
                localStorage.removeItem("token");
                dispatch(checkLogin(false));
                navigate("/");
            } else {
                dispatch(checkLogin(true));
            }
        } else {
            dispatch(checkLogin(false));
            navigate("/");
        }
    }, []);

    // reload 변경 시마다 API 다시 호출
    useEffect(() => {
        fetchCommonData();
    }, [reload]);

    // 공통 데이터 로드
    const fetchCommonData = async () => {
        setSpinner(true);
        try {
            const response = await axios.get(
                process.env.REACT_APP_API + "/api/wallet-common"
            );
            let tmp = response.data;
            if (tmp?.code === 1000) {
                // API 구조에 따라 값이 존재하면 세팅
                const c = tmp?.data?.common?.[0];
                const newData = {
                    termUrl: c?.termUrl || "",
                    privacyUrl: c?.privacyUrl || "",
                    prepareUrl: c?.prepareUrl || "",
                    telegramMiniappUrl: c?.telegramMiniappUrl || "",
                };
                // 현재 표시값/원본값 동기화
                setCommonData(newData);
                setOriginalData(newData);
            }
            setSpinner(false);
        } catch (error) {
            console.error(error);
            setSpinner(false);
        }
    };

    // 입력값 변경 핸들러
    const onChangeValue = (e) => {
        const { name, value } = e.target;
        setCommonData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    // 저장 (수정 완료) 버튼
    const onSubmitUpdate = async () => {
        try {
            setSpinner(true);
            const response = await axios.post(
                process.env.REACT_APP_API + "/api/wallet-common/update",
                {
                    termUrl: commonData.termUrl,
                    privacyUrl: commonData.privacyUrl,
                    prepareUrl: commonData.prepareUrl,
                    telegramMiniappUrl: commonData.telegramMiniappUrl,
                }
            );
            let tmp = response.data;
            if (tmp?.code === 1000) {
                // 저장 성공 시
                // 1) 수정 모드 해제
                setChangeValue(false);
                // 2) 원본값 갱신 (== 새 값이 서버와 동기화되었으므로)
                setOriginalData(commonData);
                // 3) 필요하다면 re-fetch
                // setReload((prev) => !prev);
            } else {
                alert(tmp?.msg || "수정에 실패했습니다.");
            }
            setSpinner(false);
        } catch (error) {
            console.error(error);
            setSpinner(false);
        }
    };

    // 취소 버튼 => commonData를 원래 값(originalData)으로 복원 + 수정 모드 해제
    const onCancel = () => {
        setCommonData(originalData);
        setChangeValue(false);
    };

    return (
        <div className="main">
            <Message message={message} />
            <div className={`main-box ${darkname}`} style={{ width: "1400px" }}>
                <div className="table-flex">
                    <div className={`member-2 ${darkname}`}>
                        <div className={`table-head ${darkname}`}>
                            <div style={{ width: "20%", minWidth: "250px" }}>설정</div>
                            <div style={{ width: "50%", minWidth: "350px" }}>URL</div>
                            <div style={{ width: "30%", minWidth: "350px" }}>비고</div>
                        </div>

                        <div className="table-body" style={{ minHeight: "200px" }}>
                            {spinner ? (
                                <div className="spinner-modal">
                                    <SyncLoader color="#003577" />
                                </div>
                            ) : (
                                <>
                                    {/* data가 없을 경우 (이론상 거의 없을 것) */}
                                    {!commonData ? (
                                        <div className="data-nofound">
                                            <img src="/img/img_nofound.png" alt="" />
                                            <img
                                                src="/img/img_nofound_dark.svg"
                                                style={{ display: "none" }}
                                                alt=""
                                            />
                                            <p>NO RECORDS FOUND</p>
                                        </div>
                                    ) : (
                                        <>
                                            {/* 1) 약관 페이지 URL */}
                                            <div className={`table-body-tr ${darkname}`}>
                                                <div
                                                    className="td"
                                                    style={{ width: "20%", minWidth: "250px" }}
                                                >
                                                    약관 페이지 URL
                                                </div>
                                                <div
                                                    className="td"
                                                    style={{ width: "50%", minWidth: "350px" }}
                                                >
                                                    {changeValue ? (
                                                        <input
                                                            name="termUrl"
                                                            value={commonData.termUrl}
                                                            onChange={onChangeValue}
                                                            placeholder="약관 페이지 URL 입력"
                                                            style={{ width: "100%", padding: "3px" }}
                                                        />
                                                    ) : (
                                                        <div style={{ cursor: "pointer" }} onClick={() => window.open(commonData.termUrl)}>{commonData.termUrl}</div>
                                                    )}
                                                </div>
                                                <div
                                                    className="td"
                                                    style={{ width: "30%", minWidth: "350px" }}
                                                >
                                                    더보기 {`>`} 약관 링크 메뉴 클릭 후 이동할 웹 페이지 URL
                                                </div>
                                            </div>

                                            {/* 2) 개인정보 페이지 URL */}
                                            <div className={`table-body-tr ${darkname}`}>
                                                <div
                                                    className="td"
                                                    style={{ width: "20%", minWidth: "250px" }}
                                                >
                                                    개인정보 페이지 URL
                                                </div>
                                                <div
                                                    className="td"
                                                    style={{ width: "50%", minWidth: "350px" }}
                                                >
                                                    {changeValue ? (
                                                        <input
                                                            name="privacyUrl"
                                                            value={commonData.privacyUrl}
                                                            onChange={onChangeValue}
                                                            placeholder="개인정보 페이지 URL 입력"
                                                            style={{ width: "100%", padding: "3px" }}
                                                        />
                                                    ) : (
                                                        <div style={{ cursor: "pointer" }} onClick={() => window.open(commonData.privacyUrl)}>{commonData.privacyUrl}</div>
                                                    )}
                                                </div>
                                                <div
                                                    className="td"
                                                    style={{ width: "30%", minWidth: "350px" }}
                                                >
                                                    더보기 {`>`} 개인정보 링크 메뉴 클릭 후 이동랄 웹 페이지 URL
                                                </div>
                                            </div>

                                            {/* 3) 준비중 페이지 URL */}
                                            <div className={`table-body-tr ${darkname}`}>
                                                <div
                                                    className="td"
                                                    style={{ width: "20%", minWidth: "250px" }}
                                                >
                                                    준비중 페이지 URL
                                                </div>
                                                <div
                                                    className="td"
                                                    style={{ width: "50%", minWidth: "350px" }}
                                                >
                                                    {changeValue ? (
                                                        <input
                                                            name="prepareUrl"
                                                            value={commonData.prepareUrl}
                                                            onChange={onChangeValue}
                                                            placeholder="준비중 페이지 URL 입력"
                                                            style={{ width: "100%", padding: "3px" }}
                                                        />
                                                    ) : (
                                                        <div style={{ cursor: "pointer" }} onClick={() => window.open(commonData.prepareUrl)}>{commonData.prepareUrl}</div>
                                                    )}
                                                </div>
                                                <div
                                                    className="td"
                                                    style={{ width: "30%", minWidth: "350px" }}
                                                >
                                                    준비중 표시 웹 페이지 URL
                                                </div>
                                            </div>

                                            {/* 4) 미니앱 봇 URL */}
                                            <div className={`table-body-tr ${darkname}`}>
                                                <div
                                                    className="td"
                                                    style={{ width: "20%", minWidth: "250px" }}
                                                >
                                                    미니앱 봇 URL
                                                </div>
                                                <div
                                                    className="td"
                                                    style={{ width: "50%", minWidth: "350px" }}
                                                >
                                                    {changeValue ? (
                                                        <input
                                                            name="telegramMiniappUrl"
                                                            value={commonData.telegramMiniappUrl}
                                                            onChange={onChangeValue}
                                                            placeholder="미니앱 봇 URL 입력"
                                                            style={{ width: "100%", padding: "3px" }}
                                                        />
                                                    ) : (
                                                        <div style={{ cursor: "pointer" }} onClick={() => window.open(commonData.telegramMiniappUrl)}>{commonData.telegramMiniappUrl}</div>
                                                    )}
                                                </div>
                                                <div
                                                    className="td"
                                                    style={{ width: "30%", minWidth: "350px" }}
                                                >
                                                    더보기 {`>`} 버전(추천하기) 메뉴 클릭 후 이동할 웹 페이지 URL
                                                </div>
                                            </div>
                                        </>
                                    )}
                                </>
                            )}
                        </div>

                        {/* 버튼 영역 */}
                        <div className="gameSetting-btn-1">
                            {changeValue ? (
                                <>
                                    <div className="gameSetting-btn-2" onClick={onCancel}>
                                        취소
                                    </div>
                                    <div className="gameSetting-btn-2" onClick={onSubmitUpdate}>
                                        저장
                                    </div>
                                </>
                            ) : (
                                <div
                                    className="gameSetting-btn-2"
                                    onClick={() => setChangeValue(true)}
                                >
                                    수정
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Common;